import { DeviceStatusResponse } from '../../API/types/Devices';
import { theme } from '../../theme/theme';
import { getFormattedDate } from '../../utils/dateUtils';

export const renderSubtitle = (activeAt: string | null, isOnline: boolean): string => (
  activeAt ? `${isOnline ? 'Online' : 'Offline'} since ${getFormattedDate(activeAt).toUpperCase()}` : ''
);

export const renderStatus = (isOnline: boolean): { label: string, color: string } => ({
  label: isOnline ? 'Online' : 'Offline',
  color: isOnline ? theme.colors.green : theme.colors.red,
});

export const renderItemsListTitle = (devicesAggregation: DeviceStatusResponse | undefined): string => {
  const totalCount = devicesAggregation?.total || 0;
  const isPlural = devicesAggregation?.online === 1 ? 'device' : 'devices';
  return `${devicesAggregation?.online || 0} online ${isPlural} out of ${totalCount}`;
};
